import http from "./httpService";

const apiEndpoint = process.env.REACT_APP_API_IDENTITY_URL + "/roles";

export async function GetRoles() {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint);
}

export default {
  GetRoles  
};
